
import { v4 as uuidv4 } from "uuid";
import React, { useState, useEffect, useRef, useCallback } from 'react';
import * as cheerio from 'cheerio';
import { Navigate } from "react-router-dom";
import {
  ArrowBack,
} from "@mui/icons-material";
import { Button, Fab, Tooltip } from "@mui/material";

import Grid from '@mui/material/Grid2';

import { AbilityEffect, Attributes, Condition, Creature, CreatureAbility, HitDiceUpgradable, iCreatureSpell, Legendaries, Potence, Sense, SENSES, Skill, SKILLS, Spell, SpellcastingEntry, TableEntry, UpgradableNumber, UpgradableNumberFeature } from "@dndModels";
import { makeStyles } from "@utilities/theme_utilities";
import { Feature, FeatureBase, FloatingFeature, ModelBase } from "@models";
import { ABILITY_SCORE_FULL_TO_ABBREV_MAP, ABILITY_SCORES, AREA_TYPES, DAMAGE_TYPES, DATA_TYPE_INFO, SIZE_TO_NUM_MAP } from "@dndModels/Constants";
import { AbilityScoreType, AreaType, CreatureFBType, DamageType, isCreatureFBType, isCreatureType, isDamageType, isSpeedType, isStatType, SpeedType } from "@dndModels/Types";

import API from "@dndUtilities/system_api";
import CommonUtilities from "@utilities/common_utilities";
// import DandDCharacterUtilities from '../../utilities/character_utilities';

import StringBox from "@components/input/strings/StringBox";
import LoadingBox from "@components/input/LoadingBox";
import DeleteButton from "@components/input/buttons/icon_buttons/DeleteButton";
import DisplayObject from '@dndComponents/display/DisplayObject';
import DisplayStringWithReplacementsRecursive from '@dndComponents/display/DisplayStringWithReplacementsRecursive';

const api = API.getInstance();
const common_util = CommonUtilities.getInstance();

const looking_for_creature_name = "Loup Garou";
const looking_for_fb_name: string = "Creature Type";

// const sb_id = "695ae0f0cfa83df9124cb5ac"; // SRD 5.2.1
// const sb_id = "6675b302a4476741138fa22b"; // PHB 5.5e
// const sb_id = "67a7afb7377680b79053207a"; // MM 5.5e
const sb_id = "6a31a4d662d977b873147d46"; // R:tHW

export default function CreatureParseAdd() {
  const [fetched, setFetched] = useState(false);
  const [loading, setLoading] = useState(false);
  const [loading_message, setLoadingMessage] = useState("");
  const [percentage, setPercentage] = useState(0);
  const [old_creatures, setOldCreatures] = useState<Creature[]>([]);
  const [all_creatures, setAllCreatures] = useState<Creature[]>([]);
  const [navigateTo, setNavigateTo] = useState<string | null>(null);
  const [parse_string, setParseString] = useState("");
  const [processing, setProcessing] = useState(false);
  const [processing_message, setProcessingMessage] = useState("");
  const [creatures, setCreatures] = useState<Creature[]>([]);
  const [expanded_creature, setExpandedCreature] = useState<Creature | undefined>(undefined);
  const [expanded_creature_text, setExpandedCreatureText] = useState("");

  const parseRef = useRef<HTMLDivElement>(null);
  
  const load = useCallback( async () => {
    const onProgress = (data_type: string, perc: number ) => {
      const dt_info = DATA_TYPE_INFO.find(o => o.data_type === data_type);
      if (perc !== 0) {
        setLoadingMessage(`Loading ${dt_info?.plural??data_type}`);
        setPercentage(perc * 100);
      } else {
        setLoadingMessage(`Loading ${dt_info?.plural??data_type}`);
      }
    };
    // Loading these is to make it so the details show properly
    let creatures_from_db = await api.getObjectsWithCallbacks<Creature>({ 
      data_type: "creature", onProgress
    });
    setAllCreatures(creatures_from_db);
    creatures_from_db = creatures_from_db.filter(o => o.source_book_ids.includes(sb_id));
    setOldCreatures(creatures_from_db);
    await api.getSetOfObjectsWithCallbacks({ 
      data_types: ["condition","creature_group","spell","item"],
      onProgress 
    });
    setLoading(false);
  }, []);

  useEffect(() => {
    if (!fetched) {
      setFetched(true);
      setLoading(true);
      setTimeout(() => {
        load();
      }, 100);
    }
  }, [fetched, load]);
  
  const useStyles = makeStyles()((theme) => {
    // console.log(theme);
    return ({
      root: {
        backgroundColor: theme.palette.secondary.main
      },
    });
  });

  const { classes, cx } = useStyles();

  const parse = async () => {
    setProcessing(true);
    setProcessingMessage("Parsing");
    setPercentage(0);

    debugger;
    const elem = parseRef.current as HTMLElement;
    const monster_elements = elem.getElementsByClassName("stat-block");
    const new_creatures: Creature[] = [];
    for (let i = 0; i < monster_elements.length; ++i) {
      const m_el = monster_elements[i];
      // const c = await parseCreature55e(m_el, sb_id); //, looking_for_creature_name, looking_for_fb_name);
      const c = await api.parseCreature55e(m_el, sb_id, looking_for_creature_name, looking_for_fb_name);
      new_creatures.push(c);
      setPercentage((i / monster_elements.length) * 100);
    }

    setCreatures(new_creatures);
    setProcessing(false);
  }
  
  // const parseCreature55e = async (m_el: Element, sb_id: string) => { // , looking_for_creature_name: string, looking_for_fb_name: string
  //   const all_creatures = await api.getObjects<Creature>({ data_type: "creature" });
  //   const old_creatures = all_creatures.filter(o => o.source_book_ids.includes(sb_id));

  //   const c = new Creature();
  //   c.source_books_old = [{ type: "Source Book", id: sb_id, third_party: false }];
  //   c.source_books = [];
  //   const sb = api.source_books.find(o => o._id === sb_id);
  //   if (sb) {
  //     c.source_books.push(sb);
  //   }
  //   let existing_c: Creature | undefined;
  //   const name_els = m_el.getElementsByClassName("monster-tooltip");
  //   if (name_els[0] instanceof HTMLElement) {
  //     // <a class="tooltip-hover monster-tooltip">Aboleth</a>
  //     c.name = common_util.capitalize_firsts(name_els[0].innerText.trim().toLocaleLowerCase());
  //     // if (c.name.includes(looking_for_creature_name) && looking_for_fb_name === "Name") {
  //     //   debugger;
  //     // }
  //     existing_c = old_creatures.find(o => o.name === c.name);
  //     if (existing_c) {
  //       await api.loadObject(existing_c);
  //     }
  //   }
  //   const p_els = m_el.getElementsByTagName("p");
  //   const attr_entry = new Attributes();
  //   const tbl_entry = new TableEntry();
  //   const resources_entry = new TableEntry();
  //   c.attributes_table.entries = [attr_entry];
  //   c.table.entries = [tbl_entry];
  //   let legendary = false;
  //   const leg_entry = new Legendaries();
  //   const stat_divs = m_el.getElementsByClassName("stats");
  //   if (stat_divs.length === 1) {
  //     // <div class="stats" data-content-chunk-id="7dea6640-cf25-4585-b2db-662dcc79e2c9">
  //     //   <div class="table-overflow-wrapper">
  //     //     <table class="physical abilities-saves" data-content-chunk-id="1e0999ef-488e-4bb9-b17b-9c69b785413f">
  //     //       <thead>
  //     //         <tr>
  //     //           <th>Ability</th>
  //     //           <th>Score</th>
  //     //           <th>Mod</th>
  //     //           <th>Save</th>
  //     //         </tr>
  //     //       </thead>
  //     //       <tbody>
  //     //         <tr>
  //     //           <th>Str</th>
  //     //           <td>21</td>
  //     //           <td>+5</td>
  //     //           <td>+5</td>
  //     //         </tr>
  //     //         <tr>
  //     //           <th>Dex</th>
  //     //           <td>9</td>
  //     //           <td>−1</td>
  //     //           <td>+3</td>
  //     //         </tr>
  //     //         <tr>
  //     //           <th>Con</th>
  //     //           <td>15</td>
  //     //           <td>+2</td>
  //     //           <td>+6</td>
  //     //         </tr>
  //     //       </tbody>
  //     //     </table>
  //     //   </div>
  //     //   <div class="table-overflow-wrapper">
  //     //     <table class="mental abilities-saves" data-content-chunk-id="c94341a1-6d75-495b-9f61-fb5672610989">
  //     //       <thead>
  //     //         <tr>
  //     //           <th>Ability</th>
  //     //           <th>Score</th>
  //     //           <th>Mod</th>
  //     //           <th>Save</th>
  //     //         </tr>
  //     //       </thead>
  //     //       <tbody>
  //     //         <tr>
  //     //           <th>Int</th>
  //     //           <td>18</td>
  //     //           <td>+4</td>
  //     //           <td>+8</td>
  //     //         </tr>
  //     //         <tr>
  //     //           <th>Wis</th>
  //     //           <td>15</td>
  //     //           <td>+2</td>
  //     //           <td>+6</td>
  //     //         </tr>
  //     //         <tr>
  //     //           <th>Cha</th>
  //     //           <td>18</td>
  //     //           <td>+4</td>
  //     //           <td>+4</td>
  //     //         </tr>
  //     //       </tbody>
  //     //     </table>
  //     //   </div>
  //     // </div>
  //     const stat_rows = stat_divs[0].getElementsByTagName("tr");
  //     for (let j = 0; j < stat_rows.length; ++j) {
  //       // <tr>
  //       //   <th>Str</th>
  //       //   <td>21</td>
  //       //   <td>+5</td>
  //       //   <td>+5</td>
  //       // </tr>
  //       const row = stat_rows[j];
  //       if (row.cells.length === 4) {
  //         const stat_name_cell = row.cells[0];
  //         const stat_score_cell = row.cells[1];
  //         const stat_mod_cell = row.cells[3];
  //         const stat_save_cell = row.cells[3];
          
  //         const stat = stat_name_cell.innerText.toLocaleUpperCase();
  //         if (isStatType(stat)) {
  //           const score = +stat_score_cell.innerText;
  //           if (!isNaN(score)) {
  //             c.ability_scores.setAbilityScore(stat, score);
  //           } else {
  //             debugger;
  //           }
  //           if (stat_mod_cell.innerText !== stat_save_cell.innerText) {
  //             attr_entry.save_profs.push(stat);
  //           }
  //         } else if (stat.length > 0 && stat !== "ABILITY") {
  //           debugger;
  //         }
  //       } else {
  //         debugger;
  //       }
  //     }
  //   }
  //   let skills_el: HTMLElement | undefined;
  //   let fbType: CreatureFBType | "Main Details" = "Main Details";
  //   let sc = false;

  //   const processFB = (p: HTMLElement, extra_ps: HTMLElement[]) => {
  //     // It's probably a FeatureBase
      
  //     const name_strings = p.getElementsByTagName("strong");
  //     if (name_strings.length > 0) {
  //       const name_strong = name_strings[0];
  //       let name = name_strong.innerText.trim();
  //       if (name.endsWith(".")) {
  //         name = name.substring(0, name.length - 1);
  //       }
  //       name = common_util.normalizeDashes(name);
  //       name = common_util.replaceAll(name, "’", "'");
  //       if (c.name.includes(looking_for_creature_name) && name.includes(looking_for_fb_name)) {
  //         console.log(name);
  //       }
  //       if ((name.includes("At Will:") || name.includes("/Day")) && sc) {
  //         // This should actually be added to the spellcasting entry.
  //         const blurg = () => {
  //           // <p><strong>At Will:</strong> <a
  //           //     class="tooltip-hover spell-tooltip">Detect
  //           //     Magic</a>, <a class="tooltip-hover spell-tooltip">Mind Spike</a>
  //           //   (level 4 version), <a class="tooltip-hover spell-tooltip">Minor
  //           //     Illusion</a>, <a class="tooltip-hover spell-tooltip">Shapechange</a>
  //           //   (Beast or Humanoid form only, no Temporary Hit Points gained from the spell, and no <a
  //           //     class="tooltip-hover rule-tooltip">Concentration</a>
  //           //   or <a class="tooltip-hover rule-tooltip">Temporary
  //           //     Hit Points</a> required to maintain the spell)</p>
  //           // <p data-content-chunk-id="0fa7dd01-cdc8-470f-986c-ffdc51f06343"><strong>1/Day Each:</strong> <a
  //           //     class="tooltip-hover spell-tooltip">Greater
  //           //     Restoration</a>, <a class="tooltip-hover spell-tooltip">Major Image</a>
  //           // </p>
  //         }
  //         blurg();
          
  //         let sc_entry = c.spellcasting_table.entries[0];
  //         if (!sc_entry) {
  //           sc_entry = new SpellcastingEntry();
  //           c.spellcasting_table.entries.push(sc_entry);
  //         }
  //         const innerText = common_util.cleanForCompare(p.innerText);
  //         const start_string = innerText.substring(0, innerText.indexOf(":"));

  //         let spell_level = -1;
  //         let cast_type: "Slot" | "At Will" | "X/Day" | "Ritual" = "Slot";
  //         let x = -1;
  //         if (start_string.includes("cantrip") || start_string.includes("level")) {
  //           const level_char = start_string[0];
  //           if (level_char === "c") {
  //             spell_level = 0;
  //           } else {
  //             spell_level = +level_char;
  //             if (isNaN(spell_level)) {
  //               debugger;
  //             }
  //           }
            
  //           const pieces = start_string.split("(");
  //           if (pieces[1]) {
  //             const use_string = pieces[1];
  //             if (use_string.includes("at will")) {
  //               cast_type = "At Will";
  //             } else if (use_string.includes("ritual")) {
  //               cast_type = "Ritual";
  //             } else if (use_string.includes("/day")) {
  //               const pieces2 = use_string.split("/");
  //               x = +pieces2[0];
  //             } else if (use_string.includes("slot")) {
  //               const pieces2 = use_string.split(" ");
  //               const slot_count = +pieces2[0];
  //               if (!isNaN(slot_count)) {
  //                 resources_entry.data[`Slot: ${spell_level}`] = slot_count;
  //               }
  //             } else {
  //               debugger;
  //             }
  //           }
  //         } else {
  //           // Different format.
  //           // <p class="Stat-Block-Styles_Stat-Block-Hanging">At will:&nbsp;
  //           //   <span><a>detect magic</a></span>,&nbsp;
  //           //   <span><a>fog cloud</a></span>,&nbsp;
  //           //   <span><a>light</a></span>
  //           // </p>
  //           // <p class="Stat-Block-Styles_Stat-Block-Hanging">3/day each:&nbsp;
  //           //   <span><a>feather fall</a></span>,&nbsp;
  //           //   <span><a>fly</a></span>,&nbsp;
  //           //   <span><a>misty step</a></span>,&nbsp;
  //           //   <span><a>telekinesis</a></span>
  //           // </p>
  //           if (start_string.includes("at will")) {
  //             cast_type = "At Will";
  //           } else if (start_string.includes("/day")) {
  //             cast_type = "X/Day";
  //             const pieces = start_string.split("/");
  //             const x_str = pieces[0].trim();
  //             x = +x_str;
  //             if (isNaN(x)) {
  //               debugger;
  //             }
  //           } else {
  //             debugger;
  //           }
  //         }

  //         // sc_entry.description += `\n${innerText}`;
  //         const p_children = p.childNodes;
  //         let last_spell: iCreatureSpell | undefined;
  //         for (let k = 0; k < p_children.length; ++k) {
  //           const node = p_children[k];
  //           if (node instanceof HTMLAnchorElement && node.classList.contains("spell-tooltip")) {
  //             const spell_anchor = node;
  //             const spell_name = common_util.cleanForCompare(spell_anchor.innerText);
  //             const spell = api.getSpellByName(spell_name);
  //             if (spell) {
  //               if (last_spell && last_spell.extra_text) {
  //                 // Clean the extra text.
  //                 // debugger;
  //                 last_spell.extra_text = last_spell.extra_text.trim();
  //                 if (last_spell.extra_text.startsWith(",")) {
  //                   last_spell.extra_text = last_spell.extra_text.substring(1);
  //                 }
  //                 if (last_spell.extra_text.endsWith(",")) {
  //                   last_spell.extra_text = last_spell.extra_text.substring(0, last_spell.extra_text.length - 1);
  //                 }
  //                 last_spell.extra_text = last_spell.extra_text.trim();
  //                 if (last_spell.extra_text.length === 0) {
  //                   delete last_spell.extra_text;
  //                 }
  //               }
  //               spell_level = spell.level;
  //               last_spell = {
  //                 spell_level,
  //                 spell_id: spell._id,
  //                 cast_type,
  //                 x
  //               };
  //               sc_entry.spells.push(last_spell);
  //             } else {
  //               debugger;
  //             }
  //           } else if (last_spell) {
  //             // debugger;
  //             let text = "";
  //             if (node.nodeName === "#text" && node.textContent) {
  //               text = node.textContent;
  //             } else if (node instanceof HTMLElement) {
  //               text = node.innerText;
  //             }
  //             if (text.length > 2) {
  //               // less than 3 generally means it's something like ', '
  //               if (!last_spell.extra_text) {
  //                 last_spell.extra_text = "";
  //               }
  //               last_spell.extra_text += text;
  //             }
  //           }
  //         }
  //       } else {
  //         // <p><strong><em>Amphibious.</em></strong> The aboleth
  //         //     can breathe air and water.</p>
  //         // <p><strong><em>Fist.</em></strong> <em>Melee Attack
  //         //   Roll:</em> +5, reach 5 ft. <em>Hit:</em> 5 (1d4 + 3) Bludgeoning damage.</p>
  //         sc = false;
  //         let desc0 = p.innerText.substring(name.length + 1).trim();
  //         if (desc0.startsWith(".")) {
  //           desc0 = desc0.substring(1).trim();
  //         }
  //         for (const pk of extra_ps) {
  //           desc0 += `<p>${pk.innerText}</p>`;
  //         }
  //         let content_str = `${desc0}`;
  //         if (content_str.includes("cost it extra moment")) {
  //           content_str = common_util.replaceAll(content_str, "cost it extra moment", "cost it extra movement");
  //         }

  //         if (name.includes("Legendary Resistance")) {
  //           // <p><strong><em>Legendary Resistance (3/Day, or 4/Day in
  //           //   Lair).</em></strong> If the aboleth fails a saving throw, it can choose to succeed instead.</p>
  //           // Not a FeatureBase. We store these in the legendaries table
  //           legendary = true;
  //           let legendary_resistances_str = name.split("(")[1];
  //           if (legendary_resistances_str) {
  //             let lair_str = "";
  //             if (legendary_resistances_str.includes(" or ")) {
  //               lair_str = legendary_resistances_str.split(" or ")[1];
  //               lair_str = lair_str.substring(0, lair_str.indexOf("/"));
                
  //               leg_entry.res_lair = +lair_str;
  //               leg_entry.actions = 0;
  //             }
  //             legendary_resistances_str = legendary_resistances_str.substring(0, legendary_resistances_str.indexOf("/"));
  //             leg_entry.resistances = +legendary_resistances_str;
  //           }
  //         } else if (name.includes("Spellcasting")) {
  //           // Not a FeatureBase. We store this in the spellcasting table.
  //           // <p><strong><em>Spellcasting.</em></strong> The dragon
  //           //   casts one of the following spells, requiring no Material components and using Charisma as the spellcasting ability
  //           //   (spell save DC 17, +9 to hit with spell attacks):</p>
  //           // <p><strong>At Will:</strong> <a>Detect
  //           //     Magic</a>, <a>Fear</a>, <a>Melf’s Acid
  //           //     Arrow</a> (level 3 version)</p>
  //           // <p><strong>1/Day Each:</strong> <a>Speak with
  //           //     Dead</a>, <a>Vitriolic
  //           //     Sphere</a></p>
  //           if (c.name.includes(looking_for_creature_name) && looking_for_fb_name === "Spellcasting") {
  //             debugger;
  //           }
  //           sc = true;
  //           const sc_entry = new SpellcastingEntry();
  //           sc_entry.level = c.challenge_rating;
  //           sc_entry.description = content_str;
  //           let desc = common_util.cleanForCompare(sc_entry.description);
  //           if (desc.includes(" as the spellcasting ability")) {
  //             let spellcasting_ability = common_util.capitalize_first(
  //               desc.substring(desc.indexOf("spellcasting ability is ") + 24));
  //             spellcasting_ability = spellcasting_ability.substring(0, 3).toUpperCase();
  //             c.spellcasting_ability = spellcasting_ability as AbilityScoreType;
  //           } else if (desc.includes("as the spellcasting")) {
  //             // The aarakocra casts one of the following spells, requiring no Material components 
  //             // and using Wisdom as the spellcasting ability (spell save DC 13):
  //             let index = desc.indexOf("as the spellcasting") - 2;
  //             while (index > 0 && desc[index] !== " ") {
  //               index--;
  //             }
  //             index++;
  //             const spellcasting_ability = desc.substring(index, index + 3).toLocaleUpperCase();
  //             if (ABILITY_SCORES.includes(spellcasting_ability)) {
  //               c.spellcasting_ability = spellcasting_ability as AbilityScoreType;
  //             }
  //           } else if (desc.includes("as spellcasting")) {
  //             // <p><strong><em>Spellcasting.</em></strong> The planetar
  //             //   casts one of the following spells, requiring no Material components and using Charisma as spellcasting ability
  //             //   (spell save DC 20):</p>
  //             let index = desc.indexOf("as spellcasting") - 2;
  //             while (index > 0 && desc[index] !== " ") {
  //               index--;
  //             }
  //             index++;
  //             const spellcasting_ability = desc.substring(index, index + 3).toLocaleUpperCase();
  //             if (ABILITY_SCORES.includes(spellcasting_ability)) {
  //               c.spellcasting_ability = spellcasting_ability as AbilityScoreType;
  //             }
  //           }
  //           if (desc.includes(" dc ")) {
  //             if (c.dc.isBlank()) {
  //               let dc_str = desc.substring(desc.indexOf(" dc ") + 4).trim();
  //               if (dc_str.includes(" ")) {
  //                 dc_str = dc_str.substring(0, dc_str.indexOf(" "));
  //               }
  //               dc_str = dc_str.replace(",","").replace(".","").replace(")","").replace(":","").trim();
  //               const dc_num = +dc_str;
  //               if (c.spellcasting_ability !== "None" && 
  //                 dc_num === (8 + c.proficiency_modifier + c.current_ability_scores.getModifier(c.spellcasting_ability))
  //               ) {
  //                 c.dc = new UpgradableNumber();
  //                 c.dc.base = 8;
  //                 c.dc.add_prof_bonus_mult = 1;
  //                 // c.dc.add_ability_mod_mult = 1;
  //                 // c.dc.add_ability_scores = [c.spellcasting_ability];
  //                 c.dc.add_stats_groups = [{ 
  //                   true_id: uuidv4().toString(),
  //                   add_ability_scores: [c.spellcasting_ability],
  //                   mod_or_score: "Mod",
  //                   add_mult: 1,
  //                   multiple_type: "And"
  //                 }];
  //                 sc_entry.description = common_util.replaceAll(sc_entry.description, ` dc ${dc_num}`, ` {dc_string.${c.spellcasting_ability}}`);
  //                 sc_entry.description = common_util.replaceAll(sc_entry.description, ` DC ${dc_num}`, ` {dc_string.${c.spellcasting_ability}}`);
  //               } else {
  //                 c.dc = new UpgradableNumber(dc_num);
  //               }
  //             }
  //           }
  //           if (desc.includes(" to hit ")) {
  //             let attack_str = desc.substring(0, desc.indexOf(" to hit ")).trim();
  //             attack_str = attack_str.substring(attack_str.lastIndexOf("+")+1);
  //             const attack_num = +attack_str;
  //             if (c.spellcasting_ability !== "None" && 
  //               attack_num === (c.proficiency_modifier + c.current_ability_scores.getModifier(c.spellcasting_ability))
  //             ) {
  //               c.magic_attack = new UpgradableNumber();
  //               c.magic_attack.add_prof_bonus_mult = 1;
  //               // c.magic_attack.add_ability_mod_mult = 1;
  //               // c.magic_attack.add_ability_scores = [c.spellcasting_ability];
  //               c.magic_attack.add_stats_groups = [{ 
  //                 true_id: uuidv4().toString(),
  //                 add_ability_scores: [c.spellcasting_ability],
  //                 mod_or_score: "Mod",
  //                 add_mult: 1,
  //                 multiple_type: "And"
  //               }];
  //               sc_entry.description = common_util.replaceAll(sc_entry.description, `+${attack_num} to hit `, `{attack_string.${c.spellcasting_ability}} to hit `);
  //             } else {
  //               c.magic_attack = new UpgradableNumber(attack_num);
  //             }
  //           }
  //           if (c.spellcasting_ability !== "None") {
  //             const stat = c.getBasicModifier(c.spellcasting_ability);
  //             const pb = c.proficiency_modifier;
  
  //             if (c.dc.base > 0) {
  //               c.dc.base -= stat + pb;
  //             } else {
  //               c.dc.base = 8;
  //             }
  //             c.dc.add_prof_bonus_mult = 1;
  //             // c.dc.add_ability_mod_mult = 1;
  //             // c.dc.add_ability_scores.push(c.spellcasting_ability);
  //             c.dc.add_stats_groups = [{ 
  //               true_id: uuidv4().toString(),
  //               add_ability_scores: [c.spellcasting_ability],
  //               mod_or_score: "Mod",
  //               add_mult: 1,
  //               multiple_type: "And"
  //             }];
  
  //             if (c.magic_attack.base > 0) {
  //               c.magic_attack.base -= stat + pb;
  //             }
  //             c.magic_attack.add_prof_bonus_mult = 1;
  //             // c.magic_attack.add_ability_mod_mult = 1;
  //             // c.magic_attack.add_ability_scores.push(c.spellcasting_ability);
  //             c.magic_attack.add_stats_groups = [{ 
  //               true_id: uuidv4().toString(),
  //               add_ability_scores: [c.spellcasting_ability],
  //               mod_or_score: "Mod",
  //               add_mult: 1,
  //               multiple_type: "And"
  //             }];
  //             c.spellcasting_table.entries = [sc_entry];
  //           }
  //         } else if (fbType !== "Main Details") {
  //           const fb = new FeatureBase();
  //           fb.creature_fb_type = fbType;

  //           const descVersions: string[] = [desc0];
  //           content_str = common_util.normalizeDashes(content_str);
  //           content_str = common_util.replaceAll(content_str, "’", "'");
  //           if (desc0 !== content_str) {
  //             descVersions.push(content_str);
  //           }
  //           if (name.includes(looking_for_fb_name) && c.name.includes(looking_for_creature_name)) {
  //             console.log([...descVersions]);
  //           }

  //           let ff: FloatingFeature | undefined = undefined; 
  //           if (!ff) {
  //             let desc_helper = common_util.replaceAll(common_util.replaceAll(content_str, ` ${c.name} `, ` {cfs} `), ` ${c.name}'`, ` {cfs}'`);
  //             if (!descVersions.includes(desc_helper)) {
  //               descVersions.push(desc_helper);
  //             }
  //             if (name.includes(looking_for_fb_name) && c.name.includes(looking_for_creature_name)) {
  //               console.log([...descVersions]);
  //             }
  //             let new_descs: string[] = [];
  //             for (const dv of descVersions) {
  //               const new_desc = common_util.replaceAll(common_util.replaceAll(dv, ` ${c.name} `, ` {cfs} `), ` ${c.name}'`, ` {cfs}'`);
  //               if (!descVersions.includes(new_desc) && !new_descs.includes(new_desc)) {
  //                 new_descs.push(new_desc);
  //               }
  //             }
  //             descVersions.push(...new_descs);
  //             if (name.includes(looking_for_fb_name) && c.name.includes(looking_for_creature_name)) {
  //               console.log([...descVersions]);
  //             }
  //             if (desc_helper === content_str) {
  //               const desc_helper2 = common_util.replaceAll(desc_helper, "\n", "");
  //               if (c.small_name.length === 0) {
  //                 if (c.name.includes(" ")) {
  //                   // debugger;
  //                   const words = common_util.cleanForCompare(c.name).split(" ").map(o => o.toLocaleLowerCase());
  //                   let small_name = "";
  //                   for (let i = 0; i < words.length; ++i) {
  //                     const word = words[i];
  //                     if (desc_helper2.includes(` ${word} `)) {
  //                       if (small_name === "") {
  //                         small_name = word;
  //                       } else {
  //                         const prev_word = words[i - 1];
  //                         if (small_name.includes(prev_word) && desc_helper2.includes(` ${small_name} ${word} `)) {
  //                           small_name += ` ${word}`;
  //                         }
  //                       }
  //                     }
  //                   }
  //                   c.small_name = small_name;
  //                 } else {
  //                   // Check for some things that don't fit the above method.
  //                   if (c.name.toLocaleLowerCase().includes("sphinx")) {
  //                     c.small_name = "sphinx";
  //                   } else {
  //                     c.small_name = c.name.toLocaleLowerCase();
  //                   }
  //                 }
  //               }
  //               if (c.small_name.length > 0) {
  //                 desc_helper = common_util.replaceAll(content_str, c.small_name, `{cfs}`);
                  
  //                 new_descs = [];
  //                 for (const dv of descVersions) {
  //                   const new_desc = common_util.replaceAll(dv, c.small_name, `{cfs}`);
  //                   if (!descVersions.includes(new_desc) && !new_descs.includes(new_desc)) {
  //                     new_descs.push(new_desc);
  //                   }
  //                 }
  //                 descVersions.push(...new_descs);
  //                 if (name.includes(looking_for_fb_name) && c.name.includes(looking_for_creature_name)) {
  //                   console.log([...descVersions]);
  //                 }
  //               }
  //             }
  //             const makeFF = (desc_str: string) => {
  //               const ff_obj: any = {
  //                 name,
  //                 description: desc_str,
  //                 feature_type: "Creature Ability"
  //               };
  //               if (name === "Multiattack") {
  //                 ff_obj.feature_type = "Minion Extra Attacks";
  //                 // Usually says something along the lines of "makes X attacks";
  //                 const sub = content_str.toLocaleLowerCase();
                  
  //                 const pieces = common_util.cleanForCompare(sub).split(" ");
  //                 const num_strings = ["two","three","four","five","six","seven","eight","nine","ten","2","3","4","5","6","7","8","9","10"];
  //                 let num_string = common_util.findOverlap(num_strings, pieces);
  //                 if (num_string.length === 0) {
  //                   // It's more complicated, so just make it 2
  //                   num_string = "2";
  //                 }
  //                 if (num_string.length > 0) {
  //                   switch(num_string) {
  //                     case "two": ff_obj.num = 2; break;
  //                     case "three": ff_obj.num = 3; break;
  //                     case "four": ff_obj.num = 4; break;
  //                     case "five": ff_obj.num = 5; break;
  //                     case "six": ff_obj.num = 6; break;
  //                     case "seven": ff_obj.num = 7; break;
  //                     case "eight": ff_obj.num = 8; break;
  //                     case "nine": ff_obj.num = 9; break;
  //                     case "ten": ff_obj.num = 10; break;
  //                     default: ff_obj.num = +num_string; break;
  //                   }
  //                   ff_obj.num -= 1;
  //                   return new UpgradableNumberFeature(ff_obj);
  //                 }
  //               } else {
  //                 const ca = new CreatureAbility(ff_obj);
  //                 if (ca instanceof CreatureAbility) {
  //                   if (c.name.includes(looking_for_creature_name) && ca.name.includes(looking_for_fb_name)) {
  //                     debugger;
  //                   }
  //                   let using_ability: AbilityScoreType | "" = "";
  //                   let using_ability_mod = -5;
                    
  //                   if (desc_str.includes("DC") && !desc_str.includes("rapple") && !desc_str.includes("(DC")) {
  //                     // New format: Strength Saving Throw: DC 12
  //                     // Old format: DC 19 Dexterity saving throw
  //                     // Needs to work with both
  //                     // debugger;
  //                     let dc = 0;
  //                     let save_type = "";
  //                     const pieces = common_util.cleanSpaces(desc_str).split(" ").map(o => o.replace(",",""));
  //                     let dc_index = -1;
  //                     for (let i = 0; i < pieces.length; ++i) {
  //                       const piece = pieces[i];
  //                       if (piece === "DC") {
  //                         dc_index = i;
  //                         break;
  //                       }
  //                     }
  //                     const dc_str = pieces[dc_index + 1].replace(",", "").replace(".","").replace(")","").replace(":","");
  //                     dc = +dc_str;
  //                     if (isNaN(dc)) {
  //                       console.error("DC Parse Error");
  //                       debugger;
  //                     } else {
  //                       // Check New Method first
  //                       let type_maybe = pieces[dc_index - 3];
  //                       if (type_maybe.length > 3) {
  //                         type_maybe = type_maybe.substring(0, 3).toLocaleUpperCase();
  //                         if (ABILITY_SCORES.includes(type_maybe)) {
  //                           save_type = type_maybe;
  //                         }
  //                       }
  //                       if (save_type === "") {
  //                         // Didn't find it, so Check Old Method
  //                         type_maybe = pieces[dc_index + 2];
  //                         if (type_maybe) {
  //                           if (type_maybe.length > 3) {
  //                             type_maybe = type_maybe.substring(0, 3).toLocaleUpperCase();
  //                             if (ABILITY_SCORES.includes(type_maybe)) {
  //                               save_type = type_maybe;
  //                             }
  //                           }
  //                         } else {
  //                           let spell_index = pieces.indexOf("spell");
  //                           if (spell_index < 0) {
  //                             spell_index = pieces.indexOf("Spell");
  //                           }
  //                           let spell: ModelBase | undefined = undefined;
  //                           if (spell_index > -1) {
  //                             // Check the words before and after spell_index
  //                             let spell_name = "";
  //                             let use_index = spell_index - 1;
  //                             while (use_index > -1) {
  //                               spell_name = (`${pieces[use_index].toLocaleLowerCase()} ${spell_name}`).trim();
  //                               // console.log(spell_name);
  //                               if (c.name.includes(looking_for_creature_name) && spell_name.toLocaleLowerCase().includes("sleep")) {
  //                                 debugger;
  //                               }
                                
  //                               spell = api.getSpellByName(spell_name);
  //                               if (spell) {
  //                                 break;
  //                               } else {
  //                                 use_index--;
  //                               }
  //                             }
  //                             if (!spell) {
  //                               spell_name = "";
  //                               use_index = spell_index + 1;
  //                               while (use_index < pieces.length) {
  //                                 spell_name = (`${spell_name} ${pieces[use_index].toLocaleLowerCase()}`).trim();
  //                                 if (c.name.includes(looking_for_creature_name) && spell_name.toLocaleLowerCase().includes("sleep")) {
  //                                   debugger;
  //                                 }
                                  
  //                                 spell = api.getSpellByName(spell_name);
  //                                 if (spell) {
  //                                   break;
  //                                 } else {
  //                                   use_index++;
  //                                 }
  //                               }
  //                             }
  //                           }
  //                           if (spell instanceof Spell) {
  //                             const save_effect = spell.effects.find(o => o.attack_type === "Save");
  //                             if (save_effect) {
  //                               save_type = save_effect.saving_throw_ability_score;
  //                             } else {
  //                               console.error(pieces);
  //                               console.error(dc_index);
  //                               console.error(dc);
  //                               debugger;
  //                             }
  //                           } else {
  //                             spell_index = pieces.indexOf("casts");
  //                             if (spell_index < 0) {
  //                               spell_index = pieces.indexOf("cast");
  //                             }
  //                             if (spell_index > -1) {
  //                               // Check the words before and after spell_index
  //                               let spell_name = "";
  //                               let use_index = spell_index - 1;
  //                               while (use_index > -1) {
  //                                 spell_name = (`${pieces[use_index].toLocaleLowerCase()} ${spell_name}`).trim();
  //                                 // console.log(spell_name);
  //                                 if (c.name.includes(looking_for_creature_name) && spell_name.toLocaleLowerCase().includes("sleep")) {
  //                                   debugger;
  //                                 }
                                  
  //                                 spell = api.getSpellByName(spell_name);
  //                                 if (spell) {
  //                                   break;
  //                                 } else {
  //                                   use_index--;
  //                                 }
  //                               }
  //                               if (!spell) {
  //                                 spell_name = "";
  //                                 use_index = spell_index + 1;
  //                                 while (use_index < pieces.length) {
  //                                   spell_name = (`${spell_name} ${pieces[use_index].toLocaleLowerCase()}`).trim();
  //                                   if (c.name.includes(looking_for_creature_name) && spell_name.toLocaleLowerCase().includes("sleep")) {
  //                                     debugger;
  //                                   }
                                    
  //                                   spell = api.getSpellByName(spell_name);
  //                                   if (spell) {
  //                                     break;
  //                                   } else {
  //                                     use_index++;
  //                                   }
  //                                 }
  //                               }
  //                             }
  //                             if (spell instanceof Spell) {
  //                               const save_effect = spell.effects.find(o => o.attack_type === "Save");
  //                               if (save_effect) {
  //                                 save_type = save_effect.saving_throw_ability_score;
  //                               } else {
  //                                 console.error(pieces);
  //                                 console.error(dc_index);
  //                                 console.error(dc);
  //                                 // debugger;
  //                               }
  //                             } else {
  //                               console.error(pieces);
  //                               console.error(dc_index);
  //                               console.error(dc);
  //                               debugger;
  //                             }
  //                           }
  //                         }
  //                       }
                        
  //                       const ability_mod = dc - 8 - c.proficiency_modifier;
                        
  //                       if (ca.name.includes("Breath")) {
  //                         // Breath Weapons the DC is generally based on CON.
  //                         if (common_util.modFromScore(c.ability_scores.CON.base) === ability_mod) {
  //                           using_ability = "CON";
  //                         }
  //                       }
  //                       if (using_ability === "") {
  //                         // This order is the most likely.
  //                         if (common_util.modFromScore(c.ability_scores.CHA.base) === ability_mod) {
  //                           using_ability = "CHA";
  //                         } else if (common_util.modFromScore(c.ability_scores.STR.base) === ability_mod) {
  //                           using_ability = "STR";
  //                         } else if (common_util.modFromScore(c.ability_scores.DEX.base) === ability_mod) {
  //                           using_ability = "DEX";
  //                         } else if (common_util.modFromScore(c.ability_scores.WIS.base) === ability_mod) {
  //                           using_ability = "WIS";
  //                         } else if (common_util.modFromScore(c.ability_scores.INT.base) === ability_mod) {
  //                           using_ability = "INT";
  //                         } else if (common_util.modFromScore(c.ability_scores.CON.base) === ability_mod) {
  //                           using_ability = "CON";
  //                         }
  //                       }
  //                       if (using_ability === "") {
  //                         // Could be anything.  Just leave it as a base.
  //                         ca.dc.base = dc;
  //                       } else {
  //                         ca.dc.base = 8;
  //                         ca.dc.add_prof_bonus_mult = 1;
  //                         // ca.dc.add_ability_mod_mult = 1;
  //                         // ca.dc.add_ability_scores.push(using_ability);
  //                         ca.dc.add_stats_groups = [{ 
  //                           true_id: uuidv4().toString(),
  //                           add_ability_scores: [using_ability],
  //                           mod_or_score: "Mod",
  //                           add_mult: 1,
  //                           multiple_type: "And"
  //                         }];
  //                         ca.description = ca.description.replace(`DC ${dc}`, `{dc_string.${using_ability}}`);
  //                         using_ability_mod = ability_mod;
  //                       }
  //                       ca.saving_throw_ability_score = ABILITY_SCORE_FULL_TO_ABBREV_MAP[save_type];
  //                     }
  //                   } else if (desc_str.includes("Attack Roll:")) {
  //                     // <p><strong><em>Fist.</em></strong> <em>Melee Attack
  //                     //   Roll:</em> +5, reach 5 ft. <em>Hit:</em> 5 (1d4 + 3) Bludgeoning damage.</p>

  //                     let attack_num = 0;
  //                     let index = desc_str.indexOf("Attack Roll:");
  //                     let attack_str = desc_str.substring(index + 12).trim();
  //                     index = attack_str.indexOf(",");
  //                     attack_str = attack_str.substring(0, index);
  //                     attack_str = attack_str.replace("+", "");
  //                     attack_num = +attack_str;
  //                     if (isNaN(attack_num)) {
  //                       // <p><strong><em>Bite.</em></strong> <em>Melee Attack
  //                       //     Roll:</em> +5 (with Advantage if the target is <a>Grappled</a> by
  //                       //   the ankheg), reach 5 ft. <em>Hit:</em> 10 (2d6 + 3) Slashing damage plus 3 (1d6) Acid damage. If the target is a
  //                       //   Large or smaller creature, it has the <a>Grappled</a>
  //                       //   condition (escape DC 13).</p>
  //                       index = attack_str.indexOf("(");
  //                       attack_str = attack_str.substring(0, index);
  //                       attack_str = attack_str.replace("+", "");
  //                       attack_num = +attack_str;
  //                     }
  //                     if (isNaN(attack_num)) {
  //                       console.error("Attack Parse Error");
  //                       debugger;
  //                     } else {
  //                       // Check New Method first
  //                       const ability_mod = attack_num - c.proficiency_modifier;
                        
  //                       if (using_ability === "") {
  //                         if (desc_str.includes("Spell")) {
  //                           // This order is the most likely.
  //                           if (common_util.modFromScore(c.ability_scores.CHA.base) === ability_mod) {
  //                             using_ability = "CHA";
  //                           } else if (common_util.modFromScore(c.ability_scores.WIS.base) === ability_mod) {
  //                             using_ability = "WIS";
  //                           } else if (common_util.modFromScore(c.ability_scores.INT.base) === ability_mod) {
  //                             using_ability = "INT";
  //                           } else if (common_util.modFromScore(c.ability_scores.STR.base) === ability_mod) {
  //                             using_ability = "STR";
  //                           } else if (common_util.modFromScore(c.ability_scores.DEX.base) === ability_mod) {
  //                             using_ability = "DEX";
  //                           } else if (common_util.modFromScore(c.ability_scores.CON.base) === ability_mod) {
  //                             using_ability = "CON";
  //                           }
  //                         } else if (desc_str.includes("Ranged")) {
  //                           // This order is the most likely.
  //                           if (common_util.modFromScore(c.ability_scores.DEX.base) === ability_mod) {
  //                             using_ability = "DEX";
  //                           } else if (common_util.modFromScore(c.ability_scores.STR.base) === ability_mod) {
  //                             using_ability = "STR";
  //                           } else if (common_util.modFromScore(c.ability_scores.CHA.base) === ability_mod) {
  //                             using_ability = "CHA";
  //                           } else if (common_util.modFromScore(c.ability_scores.WIS.base) === ability_mod) {
  //                             using_ability = "WIS";
  //                           } else if (common_util.modFromScore(c.ability_scores.INT.base) === ability_mod) {
  //                             using_ability = "INT";
  //                           } else if (common_util.modFromScore(c.ability_scores.CON.base) === ability_mod) {
  //                             using_ability = "CON";
  //                           }
  //                         } else {
  //                           // This order is the most likely.
  //                           if (common_util.modFromScore(c.ability_scores.STR.base) === ability_mod) {
  //                             using_ability = "STR";
  //                           } else if (common_util.modFromScore(c.ability_scores.DEX.base) === ability_mod) {
  //                             using_ability = "DEX";
  //                           } else if (common_util.modFromScore(c.ability_scores.CHA.base) === ability_mod) {
  //                             using_ability = "CHA";
  //                           } else if (common_util.modFromScore(c.ability_scores.WIS.base) === ability_mod) {
  //                             using_ability = "WIS";
  //                           } else if (common_util.modFromScore(c.ability_scores.INT.base) === ability_mod) {
  //                             using_ability = "INT";
  //                           } else if (common_util.modFromScore(c.ability_scores.CON.base) === ability_mod) {
  //                             using_ability = "CON";
  //                           }
  //                         }
  //                       }
  //                       if (using_ability === "") {
  //                         // Could be anything.  Just leave it as a base.
  //                         ca.attack_bonus.base = attack_num;
  //                       } else {
  //                         ca.attack_bonus.add_prof_bonus_mult = 1;
  //                         // ca.attack_bonus.add_ability_mod_mult = 1;
  //                         // ca.attack_bonus.add_ability_scores.push(using_ability);
  //                         ca.attack_bonus.add_stats_groups = [{ 
  //                           true_id: uuidv4().toString(),
  //                           add_ability_scores: [using_ability],
  //                           mod_or_score: "Mod",
  //                           add_mult: 1,
  //                           multiple_type: "And"
  //                         }];
  //                         ca.description = ca.description.replace(`Attack Roll: ${common_util.addPlusMaybe(attack_num)}`, `Attack Roll: {attack_string.${using_ability}}`);
  //                         using_ability_mod = ability_mod;
  //                       }
  //                     }
  //                   }
  //                   if (desc_str.includes("reach")) {
  //                     let sub = desc_str.substring(desc_str.indexOf("reach") + 5).trim();
  //                     sub = sub.substring(0, sub.indexOf(" ")).trim();
  //                     ca.range = sub;
  //                   } else if (desc_str.includes("range")) {
  //                     let sub = desc_str.substring(desc_str.indexOf("range") + 5).trim();
  //                     sub = sub.substring(0, sub.indexOf(" ")).trim();
  //                     ca.range = sub;
  //                   }
  //                   let damage_str = desc_str.toLocaleLowerCase();
  //                   const lower_case = ca.description.toLowerCase();
  //                   // if (name.includes(looking_for_fb_name)) {
  //                   //   console.log(damage_str);
  //                   // }
  //                   while (damage_str.includes("damage")) {
  //                     let damage_sub = damage_str.substring(0, damage_str.indexOf("damage") - 1).trim();
  //                     damage_str = damage_str.substring(damage_str.indexOf("damage") + 6);
  //                     const words = damage_sub.split(" ");
  //                     // console.log(words);
  //                     const damage_type = common_util.capitalize_first(words[words.length - 1]);
  //                     if (damage_sub.includes("(") && damage_sub.includes(")")) {
  //                       let start_index = damage_sub.indexOf("(");
  //                       start_index -= 2;
  //                       while (start_index >= 0 && damage_sub[start_index] !== " ") {
  //                         start_index--;
  //                       }
  //                       let replace_me = damage_sub.substring(start_index);
  //                       const end_index = replace_me.indexOf(")") + 1;
  //                       replace_me = replace_me.substring(0, end_index).trim();
  //                       damage_sub = damage_sub.substring(damage_sub.indexOf("("));
  //                       damage_sub = damage_sub.substring(0, damage_sub.indexOf(")"));
  //                       damage_sub = damage_sub.replace("(","").replace(")","");
  //                       damage_sub = common_util.normalizeDashes(damage_sub);
  //                       let count = 0;
  //                       let size = 0;
  //                       let flat = 0;
  //                       if (damage_sub.includes("+")) {
  //                         const flat_str = damage_sub.substring(damage_sub.indexOf("+")).replace("+","");
  //                         damage_sub = damage_sub.substring(0, damage_sub.indexOf("+")).replace("+","");
  //                         flat = +flat_str;
  //                       } else if (damage_sub.includes("-")) {
  //                         const flat_str = damage_sub.substring(damage_sub.indexOf("-")).replace("-","");
  //                         damage_sub = damage_sub.substring(0, damage_sub.indexOf("-")).replace("-","");
  //                         flat = -1 * +flat_str;
  //                       } 
  //                       if (damage_sub.includes("d")) {
  //                         const pieces = damage_sub.split("d");
  //                         count = +pieces[0];
  //                         size = +pieces[1];
  //                       }
  //                       const effect = new AbilityEffect();
  //                       effect.type = "Damage";
  //                       effect.damage_types.push(isDamageType(damage_type) ? damage_type as DamageType : "Typeless");
  //                       if (ca.effects.length === 0) {
  //                         const first_part = lower_case.substring(0, 20);
  //                         if (first_part.includes("melee")) {
  //                           if (first_part.includes("spell")) {
  //                             effect.attack_type = "Melee Spell";
  //                           } else {
  //                             effect.attack_type = "Melee";
  //                           }
  //                         } else if (first_part.includes("ranged")) {
  //                           if (first_part.includes("spell")) {
  //                             effect.attack_type = "Ranged Spell";
  //                           } else {
  //                             effect.attack_type = "Ranged";
  //                           }
  //                         } else if (ca.saving_throw_ability_score !== "") {
  //                           effect.attack_type = "Save";
  //                           effect.saving_throw_ability_score = ca.saving_throw_ability_score;
  //                         }
  //                         if (ca.range !== "") {
  //                           try {
  //                             const range = +ca.range;
  //                             if (!isNaN(range)) {
  //                               effect.target_int.range.base = range;
  //                             }
  //                           } catch (ex) { }
  //                         }
  //                         // X-foot cone
  //                         if (ca.description.includes("-foot")) {
  //                           const foot_index = ca.description.indexOf("-foot");
  //                           let area_str = "";
  //                           let i = 1;
  //                           while (ca.description[foot_index - i] !== " ") {
  //                             area_str = ca.description[foot_index - i] + area_str;
  //                             ++i;
  //                           }
  //                           // debugger;
  //                           i = 6;
  //                           let shape_str = "";
  //                           while (ca.description[foot_index + i] !== " ") {
  //                             shape_str += ca.description[foot_index + i];
  //                             ++i;
  //                           }
  //                           if (shape_str.endsWith(".")) {
  //                             shape_str = shape_str.substring(0, shape_str.length - 1);
  //                           }
  //                           effect.target_int.target_type = "Area";
  //                           try {
  //                             const area = +area_str;
  //                             if (!isNaN(area)) {
  //                               effect.target_int.area.base = area;
  //                             }
  //                           } catch (ex) { }
  //                           shape_str = common_util.capitalize_first(shape_str);
  //                           if (AREA_TYPES.includes(shape_str)) {
  //                             effect.target_int.area_type = shape_str as AreaType;
  //                           } else {
  //                             effect.target_int.area_type = "Sphere";
  //                           }
  //                         }
  //                       }
  //                       const potence = new Potence();
  //                       potence.level = 1;
  //                       potence.rolls.count.base = count;
  //                       potence.rolls.size.base = size;
  //                       // console.log(damage_str);
  //                       // console.log(damage_sub);
  //                       if (flat !== 0) {
  //                         if (using_ability !== "" && using_ability_mod <= flat) {
  //                           potence.rolls.flat.base = flat - using_ability_mod;
  //                           // potence.rolls.flat.add_ability_mod_mult = 1;
  //                           if (using_ability === c.spellcasting_ability) {
  //                             // potence.rolls.flat.add_ability_scores.push("Spellcasting");
  //                             potence.rolls.flat.add_stats_groups = [{ 
  //                               true_id: uuidv4().toString(),
  //                               add_ability_scores: ["Spellcasting"],
  //                               mod_or_score: "Mod",
  //                               add_mult: 1,
  //                               multiple_type: "And"
  //                             }];
  //                           } else {
  //                             // potence.rolls.flat.add_ability_scores.push(using_ability);
  //                             potence.rolls.flat.add_stats_groups = [{ 
  //                               true_id: uuidv4().toString(),
  //                               add_ability_scores: [using_ability],
  //                               mod_or_score: "Mod",
  //                               add_mult: 1,
  //                               multiple_type: "And"
  //                             }];
  //                           }
  //                         } else {
  //                           potence.rolls.flat.base = flat;
  //                         }
  //                       }
  //                       ca.description = ca.description.replace(replace_me, potence.potence_string);
  //                       effect.potences.push(potence);
  //                       ca.effects.push(effect);
  //                     }
  //                   }
  //                   if (ca.effects.length === 0) {
  //                     const effect = new AbilityEffect();
  //                     if (ca.dc.isBlank()) {
  //                       effect.type = "Utility";
  //                     } else {
  //                       effect.type = "Control";
  //                       effect.attack_type = "Save";
  //                       effect.saving_throw_ability_score = ca.saving_throw_ability_score;
  //                       const conditions = api.conditions;
  //                       for (const condition of conditions.filter(o => o.common)) {
  //                         const condition_name = condition.name;
  //                         if (ca.description.includes(condition_name) || ca.description.includes(condition_name.toLowerCase())) {
  //                           effect.utility_detail = condition_name;
  //                         }
  //                       }
  //                     }
  //                     ca.effects.push(effect);
  //                   }
  //                   if (fbType === "Legendary Actions") {
  //                     // debugger;
  //                     ca.consumed_resource.resource_consumed = "Legendary Action";
  //                     if (ca.name.includes("(Costs") && ca.name.includes("Actions)")) {
  //                       try {
  //                         // (Costs X Actions)
  //                         const actions_str = ca.name.substring(ca.name.indexOf("(Costs"));
  //                         const pieces = common_util.cleanForCompare(actions_str).split(" ");
  //                         const action_num = +pieces[1];
  //                         if (!isNaN(action_num)) {
  //                           ca.consumed_resource.amount_consumed = action_num;
  //                         }
  //                       } catch (ex) { }
  //                     } else {
  //                       ca.consumed_resource.amount_consumed = 1;
  //                     }
  //                   } else {
  //                     if (ca.name.includes("/Day)")) {
  //                       ca.consumed_resource.amount_consumed = 1;
                        
  //                       const times_index = ca.name.indexOf("/Day");
                        
  //                       let times_str = "";
  //                       let i = 1;
  //                       while (ca.name[times_index - i] !== " ") {
  //                         times_str = ca.name[times_index - i] + times_str;
  //                         ++i;
  //                       }
                        
  //                       try {
  //                         const times = +times_str;
  //                         if (!isNaN(times)) {
  //                           ca.consumed_resource.special_resource_amount = new UpgradableNumber(times);
  //                         }
  //                       } catch (ex) { }
  //                     }
  //                     if (fbType === "Bonus Actions") {
  //                       ca.casting_time = "BA";
  //                     } else if (fbType === "Reactions") {
  //                       ca.casting_time = "RA";
  //                     }
  //                   }
  //                   // Bite. Melee Weapon Attack: +12 to hit, reach 10 ft., one target. 
  //                   // Hit: 18 (2d10 + 7) piercing damage plus 5 (1d10) lightning damage.

  //                   // Frightful Presence. Each creature of the dragon's choice that is 
  //                   // within 120 feet of the dragon and aware of it must succeed on a 
  //                   // DC 17 Wisdom saving throw or become frightened for 1 minute. 
  //                   // A creature can repeat the saving throw at the end of each of its turns, 
  //                   // ending the effect on itself on a success. If a creature's saving throw 
  //                   // is successful or the effect ends for it, the creature is immune to the 
  //                   // dragon's Frightful Presence for the next 24 hours.

  //                   if (ca.range.length > 0 && ca.effects.length > 0) {
  //                     const pieces = ca.range.split("/");
  //                     const range1 = +pieces[0];
  //                     const range2 = pieces.length > 1 ? +pieces[1] : 0;
  //                     if (!isNaN(range1) && !isNaN(range2)) {
  //                       ca.effects[0].target_int.range.base = range1;
  //                       ca.effects[0].target_int.range2.base = range2;
  //                     }
  //                   }
  //                   // Lightning Breath (Recharge 5–6)
  //                   // Ink Cloud (1/Day)
  //                   if (ca.name.includes("(Recharge 5-6)")) {
  //                     ca.consumed_resource.recharge_die = 6;
  //                     ca.consumed_resource.recharge_on = [5,6];
  //                     ca.consumed_resource.resource_consumed = "Recharge";
  //                   } else if (ca.name.includes("(Recharge 4-6)")) {
  //                     ca.consumed_resource.recharge_die = 6;
  //                     ca.consumed_resource.recharge_on = [4,5,6];
  //                     ca.consumed_resource.resource_consumed = "Recharge";
  //                   } else if (ca.name.includes("(Recharge 6)")) {
  //                     ca.consumed_resource.recharge_die = 6;
  //                     ca.consumed_resource.recharge_on = [6];
  //                     ca.consumed_resource.resource_consumed = "Recharge";
  //                   } else if (ca.name.includes("/Day)")) {
  //                     ca.consumed_resource.resource_consumed = "Special";
  //                     ca.consumed_resource.amount_consumed = 1;
  //                     ca.consumed_resource.special_resource_refresh_rule = "Long Rest";
  //                     try {
  //                       let pieces = ca.name.split("(");
  //                       pieces = pieces[1].split("/");
  //                       const x_day = +pieces[0];
  //                       if (!isNaN(x_day)) {
  //                         ca.consumed_resource.special_resource_amount = new UpgradableNumber(x_day);
  //                       }
  //                     } catch (ex) {
  //                       ca.consumed_resource.special_resource_amount = new UpgradableNumber(1);
  //                     }
  //                   }
  //                 }
  //                 return ca;
  //               }
  //             }
  //             new_descs = [];
  //             for (const dv of descVersions) {
  //               const temp_ff = makeFF(dv);
                
  //               if (temp_ff && !descVersions.includes(temp_ff.description)) {
  //                 new_descs.push(temp_ff.description);
  //               }
  //             }
  //             descVersions.push(...new_descs);
  //             ff = makeFF(desc_helper);
  //             if (ff && !descVersions.includes(ff.description)) {
  //               descVersions.push(ff.description);
  //             }
              
  //             const desc = common_util.cleanSpaces(ff ? `${ff.description}` : `${content_str}`);
  //             if (!descVersions.includes(desc)) {
  //               descVersions.push(desc);
  //             }
  //             if (name.includes(looking_for_fb_name) && c.name.includes(looking_for_creature_name)) {
  //               console.log([...descVersions]);
  //             }
  //             new_descs = [];
  //             for (const dv of descVersions) {
  //               const new_desc = common_util.cleanSpaces(dv);
  //               if (!descVersions.includes(new_desc) && !new_descs.includes(new_desc)) {
  //                 new_descs.push(new_desc);
  //               }
  //             }
  //             descVersions.push(...new_descs);
  //             let ffsWithName: FloatingFeature[] = [];
  //             if (ff) {
  //               const desc = ff.description;
  //               const feature_type = ff.feature_type;
  //               ffsWithName = ff && ff.feature_type === "Creature Ability" ? 
  //                 api.all_creature_features.filter(o => o.name === name) :
  //                 api.all_floating_features.filter(o => o.feature_type === feature_type && o.name === name);
  //             }
  //             if (name.includes(looking_for_fb_name) && c.name.includes(looking_for_creature_name)) {
  //               console.log([...descVersions]);
  //               console.log(ffsWithName.map(o => o.description));
  //             }
  //             content_str = desc; // Update the fb's description to be the best cleaned one, so we can update the ff to use it as well.
  //             let old_ff = ffsWithName.find(o => 
  //               common_util.cleanCompare(o.description, desc) //, name.includes(looking_for_fb_name) && c.name.includes(looking_for_creature_name))
  //             );
  //             if (!old_ff) {
  //               for (const dv of descVersions) {
  //                 old_ff = ffsWithName.find(o => 
  //                   common_util.cleanCompare(o.description, dv) //, name.includes(looking_for_fb_name) && c.name.includes(looking_for_creature_name))
  //                 );
  //                 if (old_ff) {
  //                   break;
  //                 }
  //               }
  //             }
  //             if (old_ff) {
  //               ff = old_ff;
  //             }
  //           }
  //           if (ff) {
  //             // debugger;
  //             if (fbType === "Actions" || fbType === "Bonus Actions" || fbType === "Reactions") {
  //               const feature = new Feature();
  //               feature.floating_feature = ff;
  //               feature.floating_feature_id = ff._id;
  //               fb.creature_fb_type = "Actions";
  //               fb.fb_name = ff.name;
  //               fb.level = c.min_challenge_rating;
  //               fb.features.push(feature);
  //             } else if (fbType === "Legendary Actions") {
  //               const feature = new Feature();
  //               feature.floating_feature = ff;
  //               feature.floating_feature_id = ff._id;
  //               fb.creature_fb_type = "Legendary Actions";
  //               fb.fb_name = ff.name;
  //               fb.level = c.min_challenge_rating;
  //               fb.features.push(feature);
  //             } else if (fbType === "Traits") {
  //               const feature = new Feature();
  //               feature.floating_feature = ff;
  //               feature.floating_feature_id = ff._id;
  //               fb.creature_fb_type = "Traits";
  //               fb.fb_name = ff.name;
  //               fb.level = c.min_challenge_rating;
  //               fb.features.push(feature);
  //             } else {
  //               // console.log(action_type);
  //               // console.log(content_str);
  //               debugger;
  //             }
  //           } else {
  //             // console.log(action_type);
  //             // console.log(content_str);
  //             debugger;
  //           }

  //           fb.fb_name = name;
  //           fb.description = content_str;
  //           c.fbs.push(fb);
  //         }
  //       } 
  //     }
  //   }

  //   for (let j = 0; j < p_els.length; ++j) {
  //     // Unfortunately, in the 2024 Basic Rules, they weren't as kind with the classes, etc, 
  //     // so we have to figure out what's going on based on the content and on previous ps.
  //     const p = p_els[j] as HTMLElement;
  //     if (j === 0) {
  //       // <p>Large Aberration, Lawful Evil</p>
  //       // They always put this line right after the name, so it will always be the first one.
  //       // <p>Medium Swarm of Tiny Beasts, Unaligned</p> 
  //       // These aren't handled properly, but there's not very many, so I'll just handle them manually.
  //       if (c.name.includes(looking_for_creature_name) && looking_for_fb_name === "Creature Type") {
  //         console.log(p);
  //         debugger;
  //       }
  //       const pieces = p.innerText.split(",");
  //       let pieces2 = common_util.cleanForCompare(pieces[0]).split(" ");
  //       c.size_ugn.base = SIZE_TO_NUM_MAP[common_util.capitalize_first(pieces2[0])];
  //       if (pieces2[1] === "or" && pieces2.length > 2) {
  //         pieces2.splice(0, 2);
  //         const alt = new UpgradableNumber();
  //         alt.base = SIZE_TO_NUM_MAP[common_util.capitalize_first(pieces2[0])];
  //         c.alternate_size_ugns.push(alt);
  //       }
  //       if (pieces2.length === 2) {
  //         const ct_str = common_util.capitalize_first(pieces2[1]);
  //         if (isCreatureType(ct_str)) {
  //           c.creature_type = ct_str;
  //         }
  //       } else if (pieces2.length > 2) {
  //         // <p class="Stat-Block-Styles_Stat-Block-Metadata">Huge fiend (demon), chaotic evil</p>
  //         // debugger;
  //         const ct_str = common_util.capitalize_first(pieces2[1]);
  //         if (isCreatureType(ct_str)) {
  //           c.creature_type = ct_str;
  //         }
  //         let subtype_str = pieces[0].substring(pieces[0].indexOf(pieces2[1]) + pieces2[1].length).trim();
  //         subtype_str = subtype_str.substring(subtype_str.indexOf("(") + 1);
  //         subtype_str = subtype_str.substring(0, subtype_str.indexOf(")"));
  //         subtype_str = common_util.capitalize_firsts(subtype_str);
  //         c.subtypes = [subtype_str];
  //       } else {
  //         debugger;
  //       }
  //       const alignment_string = pieces[1].trim();
  //       c.alignment = alignment_string;
  //     } else if (j === 1) {
  //       if (p.innerText.includes("AC")) {
  //         // <p><strong>AC</strong> 17 <strong>Initiative</strong>
  //         // +7 (17)</p>
  //         const pieces = common_util.cleanSpaces(p.innerText).split(" ");
          
  //         let working_on = pieces[0];
  //         for (let k = 1; k < pieces.length; ++k) {
  //           let piece = common_util.normalizeDashes(pieces[k]);
  //           if (piece === "Initiative") {
  //             working_on = piece;
  //           } else if (working_on === "AC") {
  //             if (c.armor_class.base === 0) {
  //               c.armor_class.base = +piece;
  //               if (isNaN(c.armor_class.base)) {
  //                 debugger;
  //               }
  //               c.ac_flavor = "";
  //             } else {
  //               c.ac_flavor += piece + " ";
  //             }
  //           } else if (working_on === "Initiative") {
  //             if (c.initiative_modifier.isBlank()) {
  //               let init = +piece;
  //               if (isNaN(init)) {
  //                 // It may be a negative initiative.
  //                 if (piece.startsWith("-")) {
  //                   piece = piece.substring(1);
  //                   init = +piece;
  //                   if (!isNaN(init)) {
  //                     init *= -1;
  //                   }
  //                 }
  //               }
  //               if (isNaN(init)) {
  //                 debugger;
  //               } else {
  //                 c.initiative_modifier.base = init - c.current_ability_scores.DEX;
  //                 // c.initiative_modifier.add_ability_mod_mult = 1;
  //                 // c.initiative_modifier.add_ability_scores.push("DEX");
  //                 c.initiative_modifier.add_stats_groups = [{ 
  //                   true_id: uuidv4().toString(),
  //                   add_ability_scores: ["DEX"],
  //                   mod_or_score: "Mod",
  //                   add_mult: 1,
  //                   multiple_type: "And"
  //                 }];
  //               }
  //             }
  //           }
  //         }
  //         c.ac_flavor = c.ac_flavor.trim();
  //       } else {
  //         debugger;
  //       }
  //     } else if (j === 2) {
  //       if (c.name.includes(looking_for_creature_name) && looking_for_fb_name === "HP") {
  //         console.log(p);
  //       }
  //       if (p.innerText.includes("HP")) {
  //         // <p><strong>HP</strong> 150 (20d10 + 40)</p>
  //         let index = p.innerText.indexOf("(");
  //         let hd_str = p.innerText.substring(index + 1).replace(")", "");
  //         index = hd_str.indexOf(" ");
  //         if (index > 0) {
  //           hd_str = hd_str.substring(0, index);
  //         }
  //         const pieces = hd_str.split("d");
  //         if (pieces.length === 2) {
  //           const hd = new HitDiceUpgradable();
  //           hd.count.base = +pieces[0];
  //           c.hit_dice.push(hd);
  //         }
  //       } else {
  //         debugger;
  //       }
  //     } else if (j === 3) {
  //       if (p.innerText.includes("Speed")) {
  //         // <p><strong>Speed</strong> 10 ft., Swim 40 ft.</p>
  //         if (c.name.includes(looking_for_creature_name) && looking_for_fb_name === "Speed") {
  //           console.log(p);
  //           debugger;
  //         }
  //         let spd_str = p.innerText;
  //         const pieces = common_util.cleanForCompare(spd_str).split(" ");
  //         let spd_type: SpeedType = "walk";
  //         for (const piece of pieces) {
  //           if (isSpeedType(piece)) {
  //             spd_type = piece;
  //           } else if (!piece.includes("ft.") && piece !== "speed") {
  //             attr_entry.speeds[spd_type] = +piece;
  //           }
  //         }
  //       } else {
  //         debugger;
  //       }
  //     } else {
  //       // At this point it's harder to predict because some get skipped.
  //       if (p.classList.contains("monster-header")) {
  //         // It's a FeatureBase type
  //         // <p class="monster-header">Traits</p>
  //         const str = p.innerText.trim();
  //         if (isCreatureFBType(str)) {
  //           if (str === "Legendary Actions") {
  //             legendary = true;
  //           }
  //           fbType = str;
  //         }
  //         sc = false;
  //       } else if (p.classList.contains("legendary-actions")) {
  //         // <p class="legendary-actions">Legendary Action Uses: 3
  //         //   (4 in Lair). Immediately after another creature’s turn, the aboleth can expend a use to take one of the
  //         //   following
  //         //   actions. The aboleth regains all expended uses at the start of each of its turns.</p>
  //         if (c.name.includes(looking_for_creature_name) && looking_for_fb_name === "Legendary") {
  //           console.log(p);
  //           debugger;
  //         }
  //         let desc = p.innerText;
  //         let index = desc.indexOf("Legendary Action Uses: ");
  //         desc = desc.substring(index + 23);
  //         index = desc.indexOf(".");
  //         desc = desc.substring(0, index).trim();
  //         desc = common_util.cleanSpaces(desc);
  //         if (desc.includes("in Lair)")) {
  //           index = desc.indexOf("(");
  //           const lair = desc.substring(index + 1);
  //           const pieces2 = lair.split(" ");
  //           const lair_num = +pieces2[0];
  //           if (isNaN(lair_num)) {
  //             debugger;
  //           } else {
  //             leg_entry.act_lair = lair_num;
  //           }
  //         }
  //         const pieces = desc.split(" ");
  //         const num = pieces.length > 0 ? +pieces[0] : 0;
  //         if (!isNaN(num) && num > 0) {
  //           leg_entry.actions = num;
  //         } else {
  //           debugger;
  //         }
  //       } else if (fbType === "Main Details") {
  //         if (p.innerText.includes("Skills")) {
  //           skills_el = p; // It needs to be processed after we know the challenge rating.
  //         } else if (p.innerText.includes("Senses")) {
  //           // <p><strong>Senses</strong> <a>Darkvision</a>
  //           //     120
  //           //     ft.; Passive Perception 20</p>
  //           if (c.name.includes(looking_for_creature_name) && looking_for_fb_name === "Senses") {
  //             debugger;
  //           }
  //           const pieces = common_util.cleanForCompare(p.innerText).split(" ");
  //           let sense: Sense | undefined;
  //           for (const piece of pieces) {
  //             const sense_str = piece.toLocaleLowerCase().replace(",", "").replace(" ", "");
  //             if (sense) {
  //               const num = +sense_str;
  //               if (!isNaN(num)) {
  //                 attr_entry.senses[sense.name] = num;
  //                 continue;
  //               } else {
  //                 sense = undefined;
  //               }
  //             }
  //             const sense_maybe = SENSES.find(o => o.name.toLocaleLowerCase().replace(" ", "").includes(sense_str));
  //             if (sense_maybe) {
  //               sense = sense_maybe;
  //             }
  //           }
  //         } else if (p.innerText.includes("Vulnerabilities")) {
  //           // <p data-content-chunk-id="d899e2ed-4505-4338-a9f4-70ff7ba276cc"><strong>Vulnerabilities</strong> Poison</p>
  //           if (c.name.includes(looking_for_creature_name) && looking_for_fb_name === "Vulnerabilities") {
  //             debugger;
  //           }
  //           const str = p.innerText.substring(p.innerText.indexOf("Vulnerabilities") + 15).trim();
  //           const pieces = common_util.cleanForCompare(str).split(" ");
  //           for (const piece of pieces) {
  //             const dt_str = piece.toLocaleLowerCase().replace(",", "").replace(" ", "");
  //             const dt_maybe = DAMAGE_TYPES.find(o => o.toLocaleLowerCase().replace(" ", "").includes(dt_str));
  //             if (dt_maybe) {
  //               attr_entry.damage_vulnerabilities.push(dt_maybe);
  //             } else {
  //               if (attr_entry.extra_damage_vulnerabilities.length > 0) {
  //                 attr_entry.extra_damage_vulnerabilities += ", ";
  //               }
  //               attr_entry.extra_damage_vulnerabilities += piece;
  //             }
  //           }
  //         } else if (p.innerText.includes("Resistances")) {
  //           // <p data-content-chunk-id="d899e2ed-4505-4338-a9f4-70ff7ba276cc"><strong>Resistances</strong> Poison</p>
  //           if (c.name.includes(looking_for_creature_name) && looking_for_fb_name === "Resistances") {
  //             debugger;
  //           }
  //           const str = p.innerText.substring(p.innerText.indexOf("Resistances") + 11).trim();
  //           const pieces = common_util.cleanForCompare(str).split(" ");
  //           for (const piece of pieces) {
  //             const dt_str = piece.toLocaleLowerCase().replace(",", "").replace(" ", "");
  //             const dt_maybe = DAMAGE_TYPES.find(o => o.toLocaleLowerCase().replace(" ", "").includes(dt_str));
  //             if (dt_maybe) {
  //               attr_entry.damage_resistances.push(dt_maybe);
  //             } else {
  //               if (attr_entry.extra_damage_resistances.length > 0) {
  //                 attr_entry.extra_damage_resistances += ", ";
  //               }
  //               attr_entry.extra_damage_resistances += piece;
  //             }
  //           }
  //         } else if (p.innerText.includes("Immunities")) {
  //           // <p data-content-chunk-id="88026590-4a67-4d4f-a8cc-b7a6529ca134"><strong>Immunities</strong> Poison; <a
  //           //         class="tooltip-hover condition-tooltip"
  //           //         href="/sources/dnd/free-rules/rules-glossary#ExhaustionCondition"
  //           //         data-tooltip-href="//www.dndbeyond.com/conditions/4-tooltip?disable-webm=1&amp;disable-webm=1">Exhaustion</a>,
  //           //     <a class="tooltip-hover condition-tooltip" href="/sources/dnd/free-rules/rules-glossary#PoisonedCondition"
  //           //         data-tooltip-href="//www.dndbeyond.com/conditions/11-tooltip?disable-webm=1&amp;disable-webm=1">Poisoned</a>
  //           // </p>
  //           if (c.name.includes(looking_for_creature_name) && looking_for_fb_name === "Immunities") {
  //             debugger;
  //           }
  //           const str = p.innerText.substring(p.innerText.indexOf("Immunities") + 10).trim();
  //           const main_pieces = str.split(";");
  //           if (main_pieces.length === 1) {
  //             // It might only be conditions
  //             let pieces = main_pieces[0].split(",").map(o => o.trim());
  //             let is_conditions = false;
  //             if (!isDamageType(pieces[0])) {
  //               const cond = api.conditions.find(o => o.name === pieces[0]);
  //               if (cond) {
  //                 is_conditions = true;
  //               }
  //             }
  //             if (is_conditions) {
  //               for (const piece of pieces) {
  //                 const cond = api.conditions.find(o => o.name === piece);
  //                 if (cond instanceof Condition) {
  //                   attr_entry.condition_immunities.push(piece);
  //                 } else {
  //                   console.error("Something weird is happening with its immunities");
  //                   debugger;
  //                 }
  //               }
  //             } else {
  //               for (const piece of pieces) {
  //                 if (isDamageType(piece)) {
  //                   attr_entry.damage_immunities.push(piece);
  //                 } else {
  //                   attr_entry.extra_damage_immunities += piece;
  //                 }
  //               }
  //             }
  //           } else {
  //             // Damage Immunities
  //             let pieces = main_pieces[0].split(",").map(o => o.trim());
  //             for (const piece of pieces) {
  //               if (isDamageType(piece)) {
  //                 attr_entry.damage_immunities.push(piece);
  //               } else {
  //                 attr_entry.extra_damage_immunities += piece;
  //               }
  //             }
  //             // Condition Immunities
  //             pieces = main_pieces[1].split(",").map(o => o.trim());
  //             for (const piece of pieces) {
  //               const cond = api.conditions.find(o => o.name === piece);
  //               if (cond instanceof Condition) {
  //                 attr_entry.condition_immunities.push(piece);
  //               } else {
  //                 console.error("Something weird is happening with its immunities");
  //                 debugger;
  //               }
  //             }
  //           }
  //         } else if (p.innerText.includes("Languages")) {
  //           // <p><strong>Languages</strong> Deep Speech; telepathy
  //           //     120 ft.</p>
  //           const language_str = common_util.cleanSpaces(p.innerText.replace("Languages", "")).trim();
  //           attr_entry.languages = language_str;
  //         } else if (p.innerText.includes("CR")) {
  //           // <p><strong>CR</strong> 10 (XP 5,900, or 7,200 in lair;
  //           //     PB +4)</p>
  //           const pieces = common_util.cleanSpaces(p.innerText.replace("CR", "").trim()).split(" ");
  //           if (pieces.length > 0) {
  //             const cr_str = pieces[0];
  //             if (cr_str.includes("/")) { // 1/4 or 1/2
  //               const pieces2 = cr_str.split("/");
  //               const num = +pieces2[0];
  //               const den = +pieces2[1];
  //               if (!isNaN(num) && !isNaN(den)) {
  //                 c.challenge_rating = num / den;
  //               } else {
  //                 debugger;
  //               }
  //             } else {
  //               const num = +cr_str;
  //               if (!isNaN(num)) {
  //                 c.challenge_rating = num;
  //               } else {
  //                 debugger;
  //               }
  //             }
  //           } else {
  //             debugger;
  //           }
  //         } else if (p.innerText.includes("Challenge")) {
  //           // <p><strong>Challenge</strong> 10 (XP 5,900, or 7,200 in lair;
  //           //     PB +4)</p>
  //           const pieces = common_util.cleanSpaces(p.innerText.replace("Challenge", "").trim()).split(" ");
  //           if (pieces.length > 0) {
  //             const cr_str = pieces[0];
  //             if (cr_str.includes("/")) { // 1/4 or 1/2
  //               const pieces2 = cr_str.split("/");
  //               const num = +pieces2[0];
  //               const den = +pieces2[1];
  //               if (!isNaN(num) && !isNaN(den)) {
  //                 c.challenge_rating = num / den;
  //               } else {
  //                 debugger;
  //               }
  //             } else {
  //               const num = +cr_str;
  //               if (!isNaN(num)) {
  //                 c.challenge_rating = num;
  //               } else {
  //                 debugger;
  //               }
  //             }
  //           } else {
  //             debugger;
  //           }
  //         } 
  //       } else {
  //         if (p.innerText.includes(looking_for_fb_name) && c.name.includes(looking_for_creature_name)) {
  //           console.log(p);
  //         }
  //         // Look for additional ps that should be part of it.
  //         // <p><strong><em>Dominate Mind (2/Day).</em></strong>
  //         //     <em>Wisdom Saving Throw:</em> DC 16, one creature the aboleth can see within 30 feet. <em>Failure:</em> The
  //         //     target
  //         //     has the <a>Charmed</a>
  //         //     condition until the aboleth dies or is on a different plane of existence from the target. While Charmed, the
  //         //     target acts as an ally to the aboleth and is under its control while within 60 feet of it. In addition, the
  //         //     aboleth and the target can communicate telepathically with each other over any distance.
  //         // </p>
  //         // <p>The target repeats the save whenever it takes damage
  //         //     as well as after every 24 hours it spends at least 1 mile away from the aboleth, ending the effect on itself on
  //         //     a
  //         //     success.</p>
  //         const extra_ps: HTMLElement[] = [];
  //         for (let k = (j + 1); k < p_els.length; k++) {
  //           const pk = p_els[k];
  //           if (pk.classList.contains("monster-header")) {
  //             break;
  //           }
  //           const name_strongs = pk.getElementsByTagName("strong");
  //           if (name_strongs.length === 0) {
  //             extra_ps.push(pk);
  //           } else {
  //             break;
  //           }
  //         }
  //         processFB(p, extra_ps);
  //       } 
  //     }
  //   }
  //   if (c.initiative_modifier.base > 0 && (c.initiative_modifier.base % c.proficiency_modifier) === 0) {
  //     c.initiative_modifier.add_prof_bonus_mult = c.initiative_modifier.base / c.proficiency_modifier;
  //     c.initiative_modifier.base = 0;
  //   }
  //   if (skills_el) {
  //     // <p><strong>Skills</strong> <a>History</a> +12,
  //     //     <a>Perception</a>
  //     //     +10
  //     // </p>
  //     if (c.name.includes(looking_for_creature_name) && looking_for_fb_name === "Skills") {
  //       debugger;
  //     }
  //     const pieces = common_util.cleanForCompare(skills_el.innerText).split(" ");
  //     const pb = c.proficiency_modifier;
  //     let skill: Skill | undefined;
  //     for (let k = 0; k < pieces.length; ++k) {
  //       const piece = pieces[k].replace(",", "").replace("+", "");
  //       let skill_mod = +piece;
  //       if (isNaN(skill_mod)) {
  //         skill = SKILLS.find(o => o.name.toLocaleLowerCase() === piece.toLocaleLowerCase());
  //         if (!skill) {
  //           // It might be animal handling.
  //           if (piece === "animal") {
  //             skill = SKILLS.find(o => o.name === "Animal Handling");
  //             ++k;
  //           } else if (piece === "sleight") {
  //             skill = SKILLS.find(o => o.name === "Sleight of Hand");
  //             ++k;
  //             ++k;
  //           }
  //         }
  //       } else if (skill) {
  //         const stat_score = c.ability_scores.getBasicScore(skill.use_ability_score);
  //         const stat_mod = common_util.modFromScore(stat_score);
  //         skill_mod -= stat_mod;
  //         attr_entry.skill_profs[skill._id] = skill_mod / pb;
  //       }
  //     }
  //   }
  //   attr_entry.level = c.challenge_rating;
  //   tbl_entry.level = c.challenge_rating;
  //   if (leg_entry.resistances > 0 || leg_entry.actions > 0) {
  //     leg_entry.level = c.challenge_rating;
  //     c.legendaries_table.entries = [leg_entry];
  //   }
  //   if (Object.keys(resources_entry.data).length > 0) {
  //     resources_entry.level = c.challenge_rating;
  //     c.resources_table.entries = [resources_entry];
  //   }
  //   if (existing_c) {
  //     if (existing_c.name.includes(looking_for_creature_name)) {
  //       // debugger;
  //       console.log(existing_c.name);
  //     }
  //     existing_c.size_ugn.copy(c.size_ugn);
  //     existing_c.alternate_size_ugns = c.alternate_size_ugns.map(o => o.clone());
  //     existing_c.armor_class.copy(c.armor_class);
  //     existing_c.ac_flavor = c.ac_flavor;
  //     existing_c.hit_dice = c.hit_dice;
  //     existing_c.ability_scores = c.ability_scores;
  //     existing_c.fbs = c.fbs;
  //     existing_c.attributes_table.entries = c.attributes_table.entries;
  //     existing_c.table.entries = c.table.entries;
  //     existing_c.legendaries_table.entries = c.legendaries_table.entries;
  //     existing_c.spellcasting_table.entries = c.spellcasting_table.entries;
  //     existing_c.spellcasting_ability = c.spellcasting_ability;
  //     existing_c.resources_table.entries = c.resources_table.entries;
  //     existing_c.small_name = c.small_name;
  //     existing_c.creature_type = c.creature_type;
  //     existing_c.subtypes = c.subtypes;
  //     const variant_group_id = existing_c.variant_group_id;
  //     const c_id = existing_c._id;
  //     // const old_dominant = all_creatures.find(o => o._id !== c_id && o.variant_group_id === variant_group_id && o.is_true_dominant);
  //     // if (old_dominant) {
  //     //   existing_c.dominance_level = old_dominant.dominance_level + 1;
  //     // }
  //     return existing_c;
  //   } else {
  //     const c_name = c.name;
  //     const old_dominant = all_creatures.find(o => o.name === c_name && o.isDominant());
  //     if (old_dominant) {
  //       // c.dominance_level = old_dominant.dominance_level + 1;
  //       c.variant_of_id = old_dominant.variant_group_id;
  //     }
  //     return c;
  //   }
  // }

  const submit = async (error_messages: string[] = []) => {
    const next_creature = creatures.find(o => !o.saved);
    if (next_creature) {
      if (next_creature.name.includes(looking_for_creature_name)) {
        debugger;
      }
      // if (make_dominant && next_creature.variant_group.length > 0) {
      //   const max_dominance_level = Math.max(...next_creature.variant_group.map(o => o.dominance_level));
      //   next_creature.dominance_level = max_dominance_level + 1;
      // }
      if (next_creature.parse_errors.length > 0) {
        error_messages.push(...next_creature.parse_errors.map(o => {
          return `${next_creature.name}: ${o}`;
        }));
      }
      for (const fb of next_creature.fbs) {
        if (fb.single_ff && fb.single_feature) {
          let upsert_it = false;
          let is_new = false;
          const ff = fb.single_ff;
          if (fb.description !== ff.description) {
            ff.description = fb.description;
            upsert_it = true;
          }
          if (ff._id === "") {
            // If it's a new ff then we want to check it against the other new ffs 
            // because it's possible that it matches one, 
            // and we don't want more than we need.
            const old_ff = ff.feature_type === "Creature Ability" ? 
              api.all_creature_features.find(o => o.name === ff.name && o.description === ff.description) :
              api.all_floating_features.find(o => o.feature_type === ff.feature_type && o.name === ff.name && o.description === ff.description);
            if (old_ff) {
              // debugger;
              upsert_it = false;
              is_new = false;
              fb.features[0].floating_feature_id = old_ff._id;
              fb.features[0].floating_feature = old_ff;
            } else {
              upsert_it = true;
              is_new = true;
            }
          }
          if (upsert_it) {
            const ff_res = await api.upsertObject(ff.data_type, ff);
            if (is_new && ff_res) {
              ff._id = ff_res.body.id;
              ff.loaded = true;
              api.add_floating_feature(ff);
              fb.single_feature.floating_feature_id = ff._id;
            }
          }
        }
      }
      setProcessingMessage(`Saving ${next_creature.name}`);
      setPercentage((creatures.filter(o => o.saved).length / creatures.length) * 100);
      const res = await api.upsertObject("creature", next_creature);
      console.log(res);
      if (res && res.body.id) {
        next_creature._id = res.body.id;
      } else {
        next_creature._id = "Error";
        error_messages.push(`${next_creature.name} Save Failed`);
      }
      next_creature.saved = true;
      submit(error_messages);
    } else {
      setCreatures([]);
      setParseString("");
      setProcessing(false);
    }
  }
  
  const modFromScore = (score: number) => {
    return Math.floor((score - 10) / 2);
  }

  const renderExpandedCreature = () => {
    return (
      <DisplayStringWithReplacementsRecursive 
        display_string={expanded_creature_text} 
        cfs={expanded_creature} 
        // log_it 
      />
    );
  }

  const renderUnmatchedFBs = (creature: Creature) => {
    const unmatched_fbs = creature.fbs.filter(o => !o.single_ff || o.single_ff._id === "");
    return unmatched_fbs.map(o => o.fb_name).join(", ");
  }

  const renderCreatures = () => {
    return (
      <Grid size={12}>
        <Grid container spacing={0} direction="row">
          <Grid
            className="header centered"
            size={12}>Creatures Ready to Add</Grid>
          <Grid size={4}>
            <Button
              variant="contained"
              color="primary"
              disabled={ processing }
              onClick={() => { setCreatures(creatures.filter(o => !o.parse_errors.includes("Variant on Book Already Exists."))); }}>
              Remove All Already in Source
            </Button>
          </Grid>
          <Grid size={4}>
            <Button
              variant="contained"
              color="primary"
              disabled={ processing }
              onClick={() => {
                setProcessing(true);
                setPercentage(0);
                submit();
              }}>
              Save All
            </Button>
          </Grid>
          <Grid size={4}>
            <Button
              variant="contained"
              color="primary"
              disabled={ processing }
              onClick={() => { setCreatures([]); }}>
              Cancel
            </Button>
          </Grid>
          { creatures.map(creature => {
            return (
              <Grid
                key={creature.name}
                className="padded"
                size={12}>
                <Grid container spacing={0} direction="row"className={cx(classes.root)}>
                  <Grid
                    onClick={ async () => { 
                      if (expanded_creature && expanded_creature.name === creature.name) {
                        setExpandedCreature(undefined);
                        setExpandedCreatureText("");
                      } else {
                        setExpandedCreature(creature); 
                        setExpandedCreatureText(await api.formattedCreatureStatBlock(creature));
                      }
                    }}
                    size={4}>
                    <DisplayObject
                      obj={creature}
                    />{ creature._id === "" ? " New" : " Existing" }
                  </Grid>
                  <Grid size={4}>
                    { renderUnmatchedFBs(creature) }
                    {/* <DisplayObjects type="creature" ids={creature.variant_ids} display_field="true_name" /> */}
                  </Grid>
                  <Grid size={4}>
                    <DeleteButton
                      onClick={() => {
                        if (expanded_creature && expanded_creature.name === creature.name) {
                          setExpandedCreature(undefined);
                        }
                        setCreatures(creatures.filter(o => o.name !== creature.name));
                      }}
                    />
                  </Grid>
                  { creature.parse_errors.map((error, key) => {
                    return (
                      <Grid
                        key={key}
                        className="small_label red"
                        size={12}>
                        { error }
                      </Grid>
                    );
                  })}
                  { expanded_creature && expanded_creature.name === creature.name &&
                    <>
                      <Grid size={12}>
                        { renderExpandedCreature() }
                      </Grid>
                    </>
                  }
                </Grid>
              </Grid>
            );
          })}
        </Grid>
      </Grid>
    );
  }

  const renderParser = () => {
    return (
      <>
        <Grid size={9}>
          <StringBox 
            name="Parse String"
            value={parse_string}
            onBlur={(changed: string) => {
              const $ = cheerio.load(changed);
              $('figure').remove();
              setParseString($.html());
            }}
          />
        </Grid>
        <Grid size={3}>
          <Button
            variant="contained"
            color="primary"
            disabled={ processing || parse_string.length === 0 }
            onClick={parse}>
            Parse
          </Button>
        </Grid>
        <Grid size={12}>
          <div ref={parseRef} dangerouslySetInnerHTML={{ __html: parse_string }}></div>
        </Grid>
      </>
    );
  }

  if (!fetched || loading) {
    const height = window.innerHeight - 81;
    return (<LoadingBox size={height * 0.5} height={height} width={window.innerWidth - 1} message={loading_message} percentage={percentage} />);
  } else if (navigateTo !== null) {
    return <Navigate to={navigateTo} />;
  } else {
    return (
      <Grid container spacing={0} direction="row">
        <Grid size={12}>
          <Tooltip title={`Back to Creatures`}>
            <Fab size="small" color="primary" style={{marginLeft: "8px"}}
              onClick={ () => {
                setNavigateTo(`/creature`);
              }}>
              <ArrowBack/>
            </Fab>
          </Tooltip>&nbsp;
          <span className="header">
            {/* Parse Creatures for SRD 5.2.1 */}
            {/* Parse Creatures for PHB 5.5e */}
            {/* Parse Creatures for MM 5.5e */}
            Parse Creatures for R:tHW
          </span>
        </Grid>
        { processing &&
          <Grid
            className="centered"
            size={12}>
            <LoadingBox message={processing_message} height={200} percentage={percentage} />
          </Grid>
        }
        { !processing && 
          <>
            { creatures.length > 0 ? renderCreatures() : renderParser() }
          </>
        }
      </Grid>
    );
  }
}
